angular.module('avant.customer_applications.directives').directive 'amountCleave', ->
  restrict: 'A'
  link: (scope, element, attributes, _ngModelCtrl) ->

    # Cleave is attached to an input based on a class name so we need to ensure
    # the cleave is made on the correct input by using the element name, this
    # allows the use of multiple cleaves on one page.
    scope.inputId = element.context.name

    findCorrectInput = (inputObj) ->
      for input in inputObj.toArray()
        if input.name == scope.inputId
          return input

    createCleave = (inputClass, cleaveAttrs) ->
      htmlInput = findCorrectInput $(inputClass)
      scope.inputId = new Cleave(htmlInput, cleaveAttrs)

    switch attributes.amountCleave
      when 'phone'
        createCleave('.format-phone', {
          phone: true,
          phoneRegionCode: 'US'
          delimiter: '-'
        })
      when 'phone_strict'
        createCleave('.format-phone', {
          delimiters: ['-', '-'],
          blocks: [3, 3, 4]
        })
      when 'personal_offer_4_6_5'
        createCleave('.format-offer', {
          delimiters: ['-', '-'],
          blocks: [4, 6, 5]
        })
      when 'personal_offer_4_4_4_3'
        createCleave('.format-offer', {
          delimiters: ['-', '-'],
          blocks: [4, 4, 4, 3]
        })
      when 'full_date'
        createCleave('.format-date', {
          date: true,
          datePattern: ['m', 'd', 'Y']
        })
      when 'month_year_date'
        createCleave('.format-date', {
          date: true,
          datePattern: ['m', 'Y']
        })
      when 'ssn'
        createCleave('.format-ssn', {
          delimiters: ['-', '-'],
          numericOnly: true,
          blocks: [3, 2, 4]
        })
      when 'canadian_postal'
        createCleave('.format-postal', {
          delimiters: [' '],
          blocks: [3, 3]
        })
